import * as yup from "yup";

export const validationSchema = yup.object().shape({
  csv: yup.mixed().required("CSVファイルは必須です"),
});
